<template>
    <div>
        <div class="form-group"
             v-if="isDocumentAllowed('SD1')"
        >
            <label for="employmentContract"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Contrat de travail</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!employmentContract">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="employmentContract"
                               @change="addDocument($event, 'SD1')"
                        >
                    </span>
                    <a v-if="employmentContract"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('employmentContract')"
                    >{{ employmentContract.content.name }}</a>
                    <a class="close ml-1"
                       v-if="employmentContract"
                       @click="deleteDocument('SD1')"
                    >×</a>
                    <FormError v-if="!$v.employmentContract.validFileSize && !$v.employmentContract.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.employmentContract.validMimeType && !$v.employmentContract.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD2')"
        >
            <label for="employment-contract-or-training-agreement"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Contrat de travail ou convention de stage</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!employmentContractOrTrainingAgreement">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="employment-contract-or-training-agreement"
                               @change="addDocument($event, 'SD2')"
                        >
                    </span>
                    <a v-if="employmentContractOrTrainingAgreement"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('employmentContractOrTrainingAgreement')"
                    >{{ employmentContractOrTrainingAgreement.content.name }}</a>
                    <a class="close ml-1"
                       v-if="employmentContractOrTrainingAgreement"
                       @click="deleteDocument('SD2')"
                    >×</a>
                    <FormError v-if="!$v.employmentContractOrTrainingAgreement.validFileSize
                                     && !$v.employmentContractOrTrainingAgreement.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.employmentContractOrTrainingAgreement.validMimeType
                                     && !$v.employmentContractOrTrainingAgreement.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD3')"
        >
            <label for="insuranceCertificate"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Attestation d'assurance du contrat d'assurance santé dont le salarié bénéficie</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!insuranceCertificate">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="insuranceCertificate"
                               @change="addDocument($event, 'SD3')"
                        >
                    </span>
                    <a v-if="insuranceCertificate"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('insuranceCertificate')"
                    >{{ insuranceCertificate.content.name }}</a>
                    <a class="close ml-1"
                       v-if="insuranceCertificate"
                       @click="deleteDocument('SD3')"
                    >×</a>
                    <FormError v-if="!$v.insuranceCertificate.validFileSize && !$v.insuranceCertificate.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.insuranceCertificate.validMimeType && !$v.insuranceCertificate.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD8')"
        >
            <label for="swornStatement"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Déclaration sur l’honneur</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!swornStatement">Déposer la déclaration sur l’honneur</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="swornStatement"
                               @change="addDocument($event, 'SD8')"
                        >
                    </span>
                    <a v-if="swornStatement"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('swornStatement')"
                    >{{ swornStatement.content.name }}</a>
                    <a class="close ml-1"
                       v-if="swornStatement"
                       @click="deleteDocument('SD8')"
                    >×</a>
                    <FormError v-if="!$v.swornStatement.validFileSize && !$v.swornStatement.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.swornStatement.validMimeType && !$v.swornStatement.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD4')"
        >
            <label for="additionalHealthService"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Attestation de droit à la complémentaire santé solidaire</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!additionalHealthService">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="additionalHealthService"
                               @change="addDocument($event, 'SD4')"
                        >
                    </span>
                    <a v-if="additionalHealthService"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('additionalHealthService')"
                    >{{ additionalHealthService.content.name }}</a>
                    <a class="close ml-1"
                       v-if="additionalHealthService"
                       @click="deleteDocument('SD4')"
                    >×</a>
                    <FormError v-if="!$v.additionalHealthService.validFileSize && !$v.additionalHealthService.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.additionalHealthService.validMimeType && !$v.additionalHealthService.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD5')"
        >
            <label for="collectiveInsuranceOrCoverageCertificate"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
                >Attestation d'assurance du contrat santé collectif dont bénéficie le salarié du fait
                d'un autre emploi OU Document attestant que le salarié bénéficie d'une couverture
                collective en application des dispositions du 3) l'article D 911-2 du code de la
                sécurité sociale</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!collectiveInsuranceOrCoverageCertificate">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="collectiveInsuranceOrCoverageCertificate"
                               @change="addDocument($event, 'SD5')"
                        >
                    </span>
                    <a v-if="collectiveInsuranceOrCoverageCertificate"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('collectiveInsuranceOrCoverageCertificate')"
                    >{{ collectiveInsuranceOrCoverageCertificate.content.name }}</a>
                    <a class="close ml-1"
                       v-if="collectiveInsuranceOrCoverageCertificate"
                       @click="deleteDocument('SD5')"
                    >×</a>
                    <FormError v-if="!$v.collectiveInsuranceOrCoverageCertificate.validFileSize
                                     && !$v.collectiveInsuranceOrCoverageCertificate.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.collectiveInsuranceOrCoverageCertificate.validMimeType
                                     && !$v.collectiveInsuranceOrCoverageCertificate.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD6')"
        >
            <label for="responsable-health-certificate"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Attestation d'assurance d'un contrat santé responsable</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!responsableHealthCertificate">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="responsable-health-certificate"
                               @change="addDocument($event, 'SD6')"
                        >
                    </span>
                    <a v-if="responsableHealthCertificate"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('responsableHealthCertificate')"
                    >{{ responsableHealthCertificate.content.name }}</a>
                    <a class="close ml-1"
                       v-if="responsableHealthCertificate"
                       @click="deleteDocument('SD6')"
                    >×</a>
                    <FormError v-if="!$v.responsableHealthCertificate.validFileSize
                                     && !$v.responsableHealthCertificate.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.responsableHealthCertificate.validMimeType
                                     && !$v.responsableHealthCertificate.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div class="form-group"
             v-if="isDocumentAllowed('SD7')"
        >
            <label for="individual-health-certificate"
                   :class="{ 'required-field-asterisks': isDocumentRequired }"
            >Attestation d'assurance du contrat santé individuel</label>
            <div class="input-group">
                <div>
                    <span class="btn btn-primary btn-file">
                        <span v-if="!individualHealthCertificate">Déposer la pièce justificative</span>
                        <span v-else>Changer de document</span>
                        <input type="file"
                               id="individual-health-certificate"
                               @change="addDocument($event, 'SD7')"
                        >
                    </span>
                    <a v-if="individualHealthCertificate"
                       href=""
                       download
                       class="ml-2"
                       @click.prevent="downloadLocalFile('individualHealthCertificate')"
                    >{{ individualHealthCertificate.content.name }}</a>
                    <a class="close ml-1"
                       v-if="individualHealthCertificate"
                       @click="deleteDocument('SD7')"
                    >×</a>
                    <FormError v-if="!$v.individualHealthCertificate.validFileSize
                                     && !$v.individualHealthCertificate.$dirty"
                               error="La taille du fichier ne doit pas dépasser 4MO"
                    ></FormError>
                    <FormError v-if="!$v.individualHealthCertificate.validMimeType
                                     && !$v.individualHealthCertificate.$dirty"
                               error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                    ></FormError>
                </div>
            </div>
        </div>

        <div v-if="chosenReason && chosenReason.isExpirationDateRequired" class="form-group date">
            <label
                id="expirationDateLabel"
                for="expirationDate"
                :class="{ 'required-field-asterisks': isDocumentRequired }"
            >
                Date de fin de couverture assurance individuelle
            </label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="far fa-calendar-alt"></i>
                    </span>
                </div>
                <masked-input
                        type="text"
                        id="expirationDate"
                        mask="11/11/1111"
                        class="form-control float-right"
                        :class="{ 'is-invalid': $v.expirationDateLocal.$error }"
                        @input="maskedDelayTouch($v.expirationDateLocal)"
                        v-model="expirationDateLocal"
                        :disabled="isDraftPrefilledDate"
                />
            </div>
            <b-tooltip v-for="target in ['expirationDateLabel', 'expirationDate']" :target="target" :key="target" variant="secondary" triggers="hover">
                La date de fin de dispense dépend de votre situation et ne peut pas être antérieure au démarrage du contrat
            </b-tooltip>
            <FormError v-if="!$v.expirationDateLocal.validDate && $v.expirationDateLocal.$dirty"
                       error="Format de date incorrect"
            ></FormError>
            <FormError v-if="false === $v.expirationDateLocal.required && $v.expirationDateLocal.$dirty"
                       error="Veuillez renseigner la date"
            ></FormError>
            <FormError v-if="!isDraftPrefilledDate && !$v.expirationDateLocal.expirationDateAfterStartDate && $v.expirationDateLocal.$dirty"
                       error="La date de fin de dispense doit être postérieure à la date de début"
            ></FormError>
            <FormError v-if="!isDraftPrefilledDate && !$v.expirationDateLocal.expirationDateWithinOneYear && $v.expirationDateLocal.$dirty"
                       error="La date de fin de dispense ne peut pas excéder un an après la date de début"
            ></FormError>
            <FormError v-if="!isDraftPrefilledDate && !$v.expirationDateLocal.expirationDateInFuture && $v.expirationDateLocal.$dirty"
                       error="La date de fin de dispense doit être dans le futur"
            ></FormError>
          <FormError error="L'année indiquée n'est pas correcte"
                     v-if="!$v.expirationDateLocal.isValidDateYear && $v.expirationDateLocal.$dirty"
          ></FormError>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input';
    import { required } from 'vuelidate/lib/validators';

    import DocumentManager from '../mixins/documentManager';
    import FormError from './FormError';
    import ValidationDelayTouch from '../mixins/validationDelayTouch';
    import { ExemptionValidationGroups } from '../utils/validationGroups';
    import {
        fileMineTypeConstraint,
        filesizeConstraint,
        validDateConstraint,
        expirationDateAfterStartDate,
        expirationDateWithinOneYear,
        expirationDateInFuture,
        isValidDateYearConstraint
    } from '../utils/validation';

    export default {
        mixins: [DocumentManager, ValidationDelayTouch],
        props: {
            chosenReason: Object,
            exemptionReason: Object,
            expirationDate: String,
            exemptionStartDate: String,
            validationGroup: {
                type: String,
                validator: function (value) {
                    return [
                        ExemptionValidationGroups.CREATE,
                        ExemptionValidationGroups.EDIT,
                        ExemptionValidationGroups['EMPLOYEE-EDIT']
                    ].indexOf(value) !== -1
                }
            },
            enterpriseSettings: Object,
            isDraftPrefilledDate: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                employmentContract: null,
                employmentContractOrTrainingAgreement: null,
                insuranceCertificate: null,
                swornStatement: null,
                collectiveInsuranceOrCoverageCertificate: null,
                additionalHealthService: null,
                responsableHealthCertificate: null,
                individualHealthCertificate: null
            };
        },
        computed: {
            expirationDateLocal: {
               get() {
                   return this.expirationDate;
               },
               set(value) {
                   this.$emit('update:expirationDate', value)
               }
            },
            isDocumentRequired() {
                return this.validationGroup === ExemptionValidationGroups['EMPLOYEE-EDIT'];
            },
        },
        methods: {
            isDocumentAllowed(code) {
                return this.reasonContainDocumentType(code);
            }
        },
        watch: {
            expirationDateLocal(value) {
                this.$emit('update:expirationDate', value);
            },
            expirationDate(newValue, oldValue) {
                if (newValue && !oldValue) {
                    this.$nextTick(() => this.$v.expirationDateLocal.$touch());
                }
            },
            exemptionReason: {
                handler (exemptionReason) {
                    this.processDocuments(exemptionReason.documents);
                },
                deep: true
            }
        },
        components: {
            MaskedInput,
            FormError
        },
        validations() {
            let expirationDateValidators = {
                validDate: validDateConstraint,
                isValidDateYear: isValidDateYearConstraint
            };

            if (!this.isDraftPrefilledDate) {
                expirationDateValidators.expirationDateAfterStartDate = value => expirationDateAfterStartDate(value, this.exemptionStartDate);
                expirationDateValidators.expirationDateWithinOneYear = value => expirationDateWithinOneYear(value, this.exemptionStartDate);
                expirationDateValidators.expirationDateInFuture = value => expirationDateInFuture(value);
            }

            let validations = {
                expirationDateLocal: expirationDateValidators
            };

            for (const [key, value] of Object.entries(this.documentTypeToPropertyMap)) {
                if (this.isDocumentAllowed(key)) {
                    validations[value] = {
                        validFileSize: filesizeConstraint(4000000),
                        validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                    }
                }
            }

            if (this.validationGroup === ExemptionValidationGroups['EMPLOYEE-EDIT']) {
                for (const [key, value] of Object.entries(this.documentTypeToPropertyMap)) {
                    if (this.isDocumentAllowed(key)) {
                        validations[value] = {
                            ...validations[value],
                            required
                        }
                    }
                }

                if (this.chosenReason && this.chosenReason.isExpirationDateRequired) {
                    validations.expirationDateLocal = {
                        ...validations.expirationDateLocal,
                        required
                    }
                }
            }

            return validations;
        },
    }
</script>

<style scoped>
    .close {
        float: none;
        cursor: pointer
    }
</style>